import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { filter, Observable, tap } from 'rxjs';
import { Product } from '../../models/products.model'; // Importamos la interfaz Product
import { environment } from '../../../environments/environment'; // Importamos el entorno
import { AuthService } from '../auth/auth.service';
import { SwalService } from '../utls/swal.service';
@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  private apiUrl = environment.apiUrl;
  private routerApi = 'api/product';
  private routerCat = 'api/category';
  private routerBanners = 'api/banners';
  private routerApiService = 'api/services';
  private providerUs = 'api/providerUs';
  private routerUser = 'api/users';

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private swalService: SwalService
  ) {}
  getProducts(
    page: string,
    filters?: { nombreProducto?: string; idProvaider?: string }
  ): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    let params = new HttpParams();

    if (filters) {
      if (filters.nombreProducto) {
        params = params.set('nombreProducto', filters.nombreProducto);
      }
      if (filters.idProvaider) {
        params = params.set('idProvaider', filters.idProvaider);
      }
    }

    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/${page}`, {
      headers,
      params,
    });
  }
  getproductsServiceHome(): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    let params = new HttpParams();
    params = params.set('lat', '8.5505357');
    params = params.set('lng', '-71.2476575');

    return this.http.get<any>(
      `${this.apiUrl}/${this.providerUs}/homeProviders`,
      { headers, params }
    );
  }

  getCategory(id: string): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<any>(
      `${this.apiUrl}/${this.providerUs}/getCategoryInformation/${id}`,
      { headers }
    );
  }

  getBanners(): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<any>(
      `${this.apiUrl}/${this.routerBanners}/`,
      { headers }
    );
  }

  filterProductsCategory(filters?: {
    lat?: number;
    lng?: number;
    radius?: number;
    city?: string;
    search?: string;
    categoryId?: string;
    type_filter?: string;
  }) {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    let params = new HttpParams();

    if (filters) {
      if (filters.lat) params = params.set('lat', filters.lat);
      if (filters.lng) params = params.set('lng', filters.lng);
      if (filters.radius) params = params.set('radius', filters.radius);
      if (filters.city) {
        params = params.set('city', filters.city);
        params = params.delete('lat', filters.lat);
        params = params.delete('lng', filters.lng);
      }
      if (filters.search) params = params.set('search', filters.search);
      if (filters.type_filter)
        params = params.set('type_filter', filters.type_filter);
      if (filters.categoryId && filters.categoryId.trim() !== '') {
        params = params.set('categoryId', filters.categoryId);
      }
    }

    return this.http
      .get<any>(`${this.apiUrl}/${this.providerUs}/provider/filters/app`, {
        headers,
        params,
      })
  }

  getProductText(
    page: string,
    filters?: { 
      nombreProducto?: string;
      idProvaider?: string,
      idCategoria?: string,
      idSubcategoria?: string,
      productFeatured?: string
    },
    itemsPerPage?: number,
    order?: string
  ): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    let params = new HttpParams();

    if (filters) {
      if (filters.nombreProducto) {
        params = params.set('nombreProducto', filters.nombreProducto);
      }
      if(filters.idProvaider){
        params = params.set('idProvaider', filters.idProvaider);
      }
      if(filters.idCategoria){
        params = params.set('idCategoria', filters.idCategoria);
      }
      if(filters.idSubcategoria){
        params = params.set('idSubcategoria', filters.idSubcategoria);
      }
      if(filters.productFeatured){
        params = params.set('productFeatured', filters.productFeatured);
      }

      params = params.set('limit', itemsPerPage);
        if(order){
          params = params.set('order', order);
      }
    }

    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/web/${page}`, {
      headers,
      params,
    });
  }
  getProductsType(type: string): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/${this.routerApi}/productsTypeHome/type/${type}`
    );
  }
  getDashboardGroupState(state: any): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    let params = new HttpParams();
    return this.http.get<any>(
      `${this.apiUrl}/${this.routerApi}/groupState/${state}`,
      { headers, params }
    );
  }

  // Obtener un producto por ID
  getProductCategory(busq: any, page: any): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    let params = new HttpParams()
      //.set('page', page)  // Enviar page como query param
      .set('lat', '8.5505357') // Latitud quemada
      .set('lng', '-71.2476575'); // Longitud quemada

    // Agregar category solo si tiene valor
    if (busq) {
      params = params.set('category', busq);
    }
    return this.http.get<any>(
      `${this.apiUrl}/${this.providerUs}/provider/category`,
      { headers, params }
    );
  }

  getCities(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${this.providerUs}/cities/`);
  }

  getProductById(slug: any): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    let params = new HttpParams();
    return this.http.get<any>(
      `${this.apiUrl}/${this.routerApi}/productID/${slug}`,
      { headers, params }
    );
  }
  sendProductSold(data: any): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    let params = new HttpParams();

    return this.http.post<any>(
      `${this.apiUrl}/${this.routerApi}/product/sendNotication/sold`,
      data,
      { headers, params }
    );
  }
  // Crear un nuevo producto
  createProduct(product: any): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    let params = new HttpParams();

    return this.http.post<any>(`${this.apiUrl}/${this.routerApi}`, product, {
      headers,
      params,
    });
  }
  updateProduct(id: number, product: any): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    let params = new HttpParams();
    return this.http.put<any>(
      `${this.apiUrl}/${this.routerApi}/${id}`,
      product,
      { headers, params }
    );
  }
  deleteProduct(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${this.routerApi}/${id}`);
  }
  geCommentsProducts(product: any): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/${this.routerApi}/commentsProduct/${product}`
    );
  }
  getServices(
    page: string,
    filters?: { serviceName?: string; idSubCat?: string }
  ): Observable<any> {
    const token = this.authService.getUserData()?.token;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    let params = new HttpParams();
    if (filters) {
      if (filters.serviceName) {
        params = params.set('serviceName', filters.serviceName);
      }
      if (filters.idSubCat) {
        params = params.set('idSubCat', filters.idSubCat);
      }
    }
    return this.http.get<any>(
      `${this.apiUrl}/${this.routerApiService}/${page}`,
      { headers, params }
    );
  }
  generateRaring(dataRating: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/${this.providerUs}/calification`,
      dataRating
    );
  }
  getCalificationtById(id: any): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/${this.providerUs}/getCalification/provider/${id}`
    );
  }

  getReviewsById(): Observable<any> {
    const token = this.authService.getUserData()?.token;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<any>(
      `${this.apiUrl}/${this.routerUser}/reviews/data/user`
    );
  }

  getReviewsLikeId(): Observable<any> {
    const token = this.authService.getUserData()?.token;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<any>(
      `${this.apiUrl}/${this.routerUser}/reviews/data/like/user`
    );
  }
}
